import React from 'react';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';

const BasicDatePicker = (props) => {

    return(
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <MobileDatePicker
                label={props.label}
                inputFormat="yyyy-MM-dd"
                minDate={props.minDate ? props.minDate : null}
                value={props.value ? props.value : new Date()}
                onChange={props.onChange ? (value) => props.onChange(value) : (v) => {}}
                renderInput={(params) => <TextField size='small' style={{width: '150px'}} id={props.id} {...params} />}
            />
        </LocalizationProvider>
    );
}

export default BasicDatePicker;